/* Eager UI messages (no): merged from several small families that serve eager scripts. Norwegian is the source of truth. */
// private-onboarding-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'pob.personal': 'Privatøkonomi',
  'pob.step1Eyebrow': 'Steg 1 · Bruk',
  'pob.step1Title': 'Hva vil du bruke Plumme til?',
  'pob.step1Lead': 'Velg privatøkonomi, familieøkonomi eller begge. Familie kan skrus av og på senere fra Min side.',
  'pob.personalDesc': 'Oversikt, forbruk, sparing, lån, skatt og rapporter for deg.',
  'pob.family': 'Familieøkonomi',
  'pob.familyDesc': 'Felles budsjett og fordeling i husholdningen uten å dele private transaksjoner.',
  'pob.step2Eyebrow': 'Steg 2 · Data og personvern',
  'pob.step2Title': 'Du bestemmer hva Plumme får se',
  'pob.familyLinkNote': 'En familiekobling deler bare opplysninger dere registrerer på Familie-siden. Kontoer, transaksjoner, skatt og øvrige planer forblir private.',
  'pob.readyEyebrow': 'Klar til å starte',
  'pob.readyLead': 'Velkommen som bruker hos Plumme. Hvis du en dag starter bedrift, står Plumme klar til å ta regnskapet når du trenger det.',
  'pob.inviteNote': 'Når du fortsetter, opprettes Privatøkonomi og familieinvitasjonen godtas.',
});
// assistant-control-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'acm.noAdapter': 'Assistenthandlingen har ingen godkjent adapter.',
  'acm.invoiceDraftFailed': 'Fakturautkastet kunne ikke opprettes.',
  'acm.paymentFailed': 'Betalingen kunne ikke registreres.',
  'acm.customerSaveFailed': 'Kunden kunne ikke lagres.',
  'acm.supplierSaveFailed': 'Leverandøren kunne ikke lagres.',
  'acm.productSaveFailed': 'Produktet kunne ikke lagres.',
});
// app-shell-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'shm.myBusinesses': 'Mine foretak',
  'shm.clientAssignments': 'Klientoppdrag',
  'shm.pdfLoading': 'Laster forhåndsvisning…',
  'shm.pdfDownloadNamed': 'Last ned {name}',
  'shm.pdfPage': 'Side',
});
// business-invite-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'biv.role.owner': 'Eier',
  'biv.role.accountant': 'Regnskapsfører',
  'biv.role.admin': 'Administrator',
  'biv.role.viewer': 'Lesetilgang',
  'biv.role.fallback': 'Tilgang',
  'biv.toast.nowOwner': 'Du er nå eier av {name}.',
  'biv.toast.gotAccess': 'Du har fått tilgang til {name}.',
  'biv.toast.acceptFailed': 'Kunne ikke godta invitasjonen.',
  'biv.toast.stillNotVerified': 'Adressen er fortsatt ikke bekreftet. Sjekk innboksen og søppelpost.',
  'biv.toast.declined': 'Invitasjonen er avslått.',
  'biv.toast.declineFailed': 'Kunne ikke avslå invitasjonen.',
  'biv.clientInvitation': 'Klientinvitasjon',
  'biv.signInWithInviteEmail': 'Logg inn med e-postadressen fra invitasjonen',
  'biv.noActiveInvite': 'Denne lenken er lagret, men vi finner ingen aktiv klientinvitasjon for {email}.',
  'biv.thisAccount': 'denne kontoen',
  'biv.signOutAndIn': 'Logg ut og inn med e-postadressen invitasjonen ble sendt til. Da kan Plumme vise klienten og godta tilgangen uten at du oppretter et nytt foretak.',
  'biv.later': 'Senere',
  'biv.accountantSetup': 'Regnskapsføreroppsett',
  'biv.workWithClients': 'Arbeid med klienter i Plumme',
  'biv.firmIntro': 'Jobber du i et regnskapsbyrå, oppretter du byrået her og inviterer kollegaene dine. Byråflaten er ikke en egen påloggning — den ligger i samme app, med klientoversikt, avstemming og teamchat.',
  'biv.soloIntro': 'Jobber du alene med enkeltklienter, kan du i stedet starte oppsett av et klientforetak. Inntil kontrollert eierskapsoverføring er på plass blir du registrert som eier av foretaket du oppretter.',
  'biv.createClientBusiness': 'Opprett klientforetak',
  'biv.ownershipChange': 'Eierskifte',
  'biv.accountantClientAccess': 'Regnskapsfører · Klienttilgang',
  'biv.takeOver': 'Overta {name}',
  'biv.invitedTo': 'Du er invitert til {name}',
  'biv.leadOwnership': 'Når du godtar, blir du eier av foretaket i Plumme. Bruk samme e-postadresse som invitasjonen ble sendt til.',
  'biv.leadRole': 'Invitasjonen gir rollen {role} i dette foretaket. Samme innlogging kan også brukes til egne foretak, Privatøkonomi og Ansattportal.',
  'biv.step1': 'Steg 1 · Tilgang',
  'biv.whatRoleCanDo': 'Dette kan rollen gjøre',
  'biv.canWork': 'Se og arbeide med regnskap, bilag, bankavstemming, rapporter og innleveringer for klienten.',
  'biv.cannotMoveOwner': 'Dette flytter eierrollen til deg. Tidligere eier får den tilgangen som ble valgt da invitasjonen ble sendt.',
  'biv.cannotOwn': 'Kan ikke overta eierskap, slette foretaket eller administrere andre brukere. Eier eller administrator styrer tilgangen.',
  'biv.dataSeparate': 'Klientens data holdes adskilt fra dine egne foretak, Privatøkonomi og eventuelle arbeidsgivere.',
  'biv.step2': 'Steg 2 · Klar',
  'biv.readyOwnership': 'Når du godtar, åpnes foretaket som ditt foretak. Eierskiftet loggføres med tidspunkt og brukere.',
  'biv.readyAccess': 'Når du godtar, legges foretaket under Klientoppdrag og åpnes direkte. Du kan bytte kontekst fra klientvelgeren når som helst.',
  'biv.expired': 'Invitasjonen har utløpt. Be avsenderen sende den på nytt.',
  'biv.verifyEmail': 'Bekreft e-postadressen din før invitasjonen kan godtas. Vi har sendt en lenke til {email}. Åpne den, og trykk «Jeg har bekreftet».',
  'biv.yourAddress': 'adressen din',
  'biv.accountantInvitation': 'Regnskapsførerinvitasjon',
  'biv.back': '← Tilbake',
  'biv.checking': 'Sjekker...',
  'biv.iHaveVerified': 'Jeg har bekreftet',
  'biv.accepting': 'Godtar...',
  'biv.acceptAndOpen': 'Godta og åpne klienten',
  'biv.pendingTitle': 'Klientinvitasjon venter',
  'biv.pendingText': 'Logg inn med e-postadressen invitasjonen ble sendt til for å godta tilgangen.',
  'biv.viewInvitation': 'Se invitasjon',
  'biv.expiredOwnership': 'Utløpt eierskifte',
  'biv.expiredInvitation': 'Utløpt klientinvitasjon',
  'biv.newOwnership': 'Nytt eierskifte',
  'biv.newInvitation': 'Ny klientinvitasjon',
  'biv.askSenderResend': 'Be avsender sende på nytt',
  'biv.viewAccess': 'Se tilgang',
});
// backend-actions-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'bam.inv.pickFromTo': 'Velg både fra- og tilkonto.',
  'bam.inv.sameAccount': 'Fra- og tilkonto kan ikke være samme konto.',
  'bam.inv.vatCodeNotAllowed': 'Konto {code} kan ikke ha MVA-kode i fri postering.',
  'bam.inv.describeAllPostings': 'Legg inn beskrivelse på alle posteringer før du bokfører.',
  'bam.inv.validDate': 'Velg en gyldig dato.',
  'bam.inv.receiptFailed': 'Kunne ikke lage kvittering.',
  'bam.inv.lostOnlyPostedPurchases': 'Bilag borte kan bare markeres på bokførte kjøp.',
  'bam.inv.noActivePurchaseWithoutVoucher': 'Fant ikke et aktivt kjøp uten bilag.',
  'bam.inv.missingOffsetDocs': 'Mangler faktura eller kreditnota for motregning.',
  'bam.inv.missingOffsetToReverse': 'Mangler faktura eller motregning som skal reverseres.',
  'bam.inv.missingRefundInvoice': 'Mangler faktura for tilbakebetaling.',
  'bam.inv.missingAllocationInvoices': 'Mangler kilde- eller målfaktura for fordeling.',
  'bam.inv.missingAllocationToReverse': 'Mangler faktura eller fordeling som skal reverseres.',
  'bam.inv.settleNeedsFreePosting': 'Oppgjør uten betaling krever en aktiv fri postering.',
  'bam.inv.missingSupplierInvoiceSettle': 'Mangler leverandørfaktura for oppgjør.',
  'bam.inv.supplierInvoiceNotFound': 'Leverandørfakturaen ble ikke funnet.',
  'bam.inv.supplierInvoiceNothingRemaining': 'Leverandørfakturaen har ikke noe gjenstående beløp.',
  'bam.inv.freePostingNoMatchingAmount': 'Den frie posteringen mangler et ubrukt, samsvarende beløp på debet 2400.',
  'bam.inv.missingSupplierInvoiceOverpayment': 'Mangler leverandørfaktura for overbetalingen.',
  'bam.inv.missingFreePostingToLink': 'Mangler fri postering som skal kobles.',
  'bam.inv.settleMustLinkFreePosting': 'Oppgjør uten betaling må kobles til en fri postering.',
  'bam.inv.sentAsLink': 'Fakturaen ble sendt som lenke.',
  'bam.inv.sentByEmail': 'Fakturaen ble sendt på e-post.',
  'bam.inv.receiptSentByEmail': 'Kvitteringen ble sendt på e-post.',
  'bam.inv.stepFailed': 'Steget feilet.',
  'bam.bank.missingMatchGroup': 'Mangler matchinggruppe.',
  'bam.bank.screenshotReadFailed': 'Kunne ikke lese skjermbildet.',
  'bam.bank.screenshotFormat': 'Bruk et skjermbilde i PNG-, JPEG- eller WebP-format.',
  'bam.bank.screenshotTooLarge': 'Skjermbildet må være mindre enn 8 MB.',
  'bam.bank.screenshotTimeout': 'Det tok for lang tid å lese skjermbildet. Prøv igjen eller last opp originalfilen.',
  'bam.bank.openingSetupMissing': 'Bankkontoen mangler oppstartsdato eller startsaldo. Fyll inn begge i bankinnstillingene; skriv 0 dersom saldoen var null.',
  'bam.bank.ledgerMismatch': 'Bankavstemmingen har avvik mot hovedboken eller posteringer før startsaldo. Kontroller saldo og posteringer før perioden ferdigstilles.',
  'bam.bank.missingStatement': 'Mangler bankutskrift.',
  'bam.billing.supplierNumberInUse': 'Leverandørnummer {number} er allerede i bruk.',
  'bam.billing.incomeAccountFormat': 'Inntektskonto må starte på 3 og ha 4 eller 5 siffer.',
  'bam.billing.incomeAccountName': 'Gi den nye inntektskontoen et navn.',
  'bam.billing.incomeAccountStandard': 'Velg hvilken standard inntektskonto kontoen tilsvarer.',
  'bam.billing.accountExists': 'Konto {code} finnes allerede.',
  'bam.billing.missingTextLine': 'Mangler tekstlinje.',
  'bam.billing.textLineNotFound': 'Tekstlinjen finnes ikke.',
  'bam.recon.internalTransfers': 'Interne overføringer korrigeres ved å reversere hele matchinggruppen.',
  'bam.recon.purchaseNotFound': 'Fant ikke kjøpet som skal korrigeres.',
  'bam.recon.pickVoucher': 'Velg et bilag før du kobler det til posten.',
  'bam.recon.originalEntryNotFound': 'Fant ikke den opprinnelige bokførte posten bak bilaget.',
  'bam.recon.cannotLinkSafely': 'Banklinjen kan ikke kobles sikkert til den bokførte posten.',
  'bam.recon.notLinked': 'Banklinjen er ikke koblet til en eksisterende post.',
  'bam.recon.loanSumMismatch': 'Avdrag, renter og gebyr må summere til bankbeløpet.',
  'bam.recon.loanSplitUnbalanced': 'Låne-/gjeldssplitten balanserer ikke. Bruk fri postering for denne banklinjen.',
  'bam.registry.noFirebaseDailyAdvice': 'Firebase er ikke konfigurert, så dagens råd er ikke tilgjengelige.',
  'bam.registry.needLoginDailyAdvice': 'Du må være innlogget for å hente dagens råd.',
  'bam.settingsData.excelImportUnavailable': 'Excel-import er ikke tilgjengelig ennå.',
  'bam.settingsData.excelExportUnavailable': 'Excel-eksport er ikke tilgjengelig ennå.',
  'bam.settingsData.pickSaftXml': 'Velg en SAF-T XML-fil.',
  'bam.settingsData.saftNorwayOnly': 'SAF-T-eksport er bare tilgjengelig for norske foretak.',
  'bam.settingsData.saftNeedsOrgNumber': 'SAF-T krever gyldig organisasjonsnummer (9 siffer) i innstillinger.',
  'bam.settingsData.saft140': 'SAF-T 1.40 må implementeres før eksport av regnskapsår fra 2027.',
  'bam.registry.lookupFailed': 'Oppslag feilet.',
  'bam.registry.brregLookupFailed': 'BRREG-oppslag feilet.',
  'bam.registry.brregSearchFailed': 'BRREG-søk feilet.',
  'bam.registry.addressLookupFailed': 'Adresseoppslag feilet.',
});
// misc-eager-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'r1e.app.viewClientInvite': 'Se klientinvitasjon',
  'r1e.app.createPersonal': 'Opprett Privatøkonomi',
  'r1e.app.imAccountant': 'Jeg er regnskapsfører',
  'r1e.acc.createViaBackend': 'Opprett konto håndteres av Plumme backend.',
  'r1e.acc.resetFollowLink': '. Følg lenken i e-posten for å lage et nytt passord.',
  'r1e.household.title': 'Invitasjon til familieøkonomi',
  'r1e.household.defaultInviter': 'En Plumme-bruker',
  'r1e.household.body': '{inviter} vil koble Familie-siden med deg. Egne kontoer og transaksjoner deles ikke.',
  'r1e.spec.schemeSaved': 'Skatte og avgiftsordning lagret',
  'r1e.spec.schemeRemoved': 'Ordning fjernet',
  'r1e.spec.addedBody': 'Spesifikasjonen er lagt til skattemeldingen. Fyll ut postene som gjelder for {company}.',
  'r1e.pub.opening': 'Åpner dokument...',
  'r1e.pub.loading': 'Laster dokumentet...',
  'r1e.pub.quantity': 'Antall',
  'r1e.pub.pdfTitle': 'Dokument-PDF',
  'r1e.pub.offerMissingData': 'Tilbudet mangler akseptdata. Be avsender sende lenken på nytt.',
  'r1e.pub.offerAlreadyAccepted': 'Tilbudet var allerede akseptert.',
  'r1e.pub.offerAccepted': 'Takk, tilbudet er akseptert.',
  'r1e.pub.offerAcceptFailed': 'Kunne ikke akseptere tilbudet.',
  'r1e.budget.codeFormat': 'Kontonummeret må ha 4 eller 5 siffer og starte på 1-8.',
  'r1e.budget.nameRequired': 'Gi den nye kontoen et navn.',
  'r1e.budget.pickStandard': 'Velg hvilken standardkonto kontoen tilsvarer.',
  'r1e.budget.accountExists': 'Konto {code} finnes allerede.',
  'r1e.budget.standardMissing': 'Standardkonto {code} finnes ikke.',
  'r1e.booking.bankAccountMissing': 'Bankkontoen mangler konto i regnskapet. Velg hovedbokskonto før bokføring.',
  'r1e.booking.pickExpenseAccount': 'Velg kostnadskonto før banklinjen bokføres.',
  'r1e.booking.invoiceNumberRequired': 'Legg inn fakturanummer før leverandørfakturaen bokføres.',
  'r1e.booking.payrollTaxFlow': 'Fra 2026 må forskuddstrekk og arbeidsgiveravgift først registreres under Lønn. Match deretter banklinjen mot det eksisterende betalingsbilaget.',
  'r1e.bookingHelpers.taxPaymentNoOnly': 'Automatisk bokfoering av skattebetaling fra bank er foreloepig bare stoettet for norske foretak.',
  'r1e.bookingHelpers.taxPaymentManualReview': 'Skattebetalingen krever manuell kontroll av foretaksform og oppgjorskonto foer bokfoering.',
  'r1e.lines.patternIdMissing': 'Mønsteret mangler identifikator.',
  'r1e.lines.correctionReasonRequired': 'Skriv kort hvorfor banklinjen korrigeres.',
  'r1e.lines.alreadyLinked': 'Banklinjen er allerede koblet eller bokført. Åpne koblingen/posteringen før avlesningen korrigeres.',
  'r1e.purchaseEditor.vatLocked': 'MVA-terminen er levert. Du kan bare endre beskrivelse og kostnadskonto/kategori på dette kjøpet. Åpne eller korriger MVA-terminen før du endrer kjøpsdato, beløp, MVA-kode eller betaling.',
  'r1e.purchaseEditor.descriptionRequired': 'Legg inn beskrivelse på alle linjer før du bokfører.',
  'r1e.state.readOnlyDemo': 'Dette foretaket er skrivebeskyttet fordi det peker på demo-data for en annen bruker.',
  'r1e.state.changedInOtherTab': 'Foretaksdata ble endret i en annen fane. Last inn siden på nytt før du lagrer igjen.',
  'r1e.autopilot.taskMissing': 'Mangler oppgave.',
  'r1e.access.memberMissing': 'Mangler bruker som skal fjernes.',
  'r1e.recon.businessOrPeriodMissing': 'Mangler foretak eller periode for dokumentet.',
  'r1e.vehicle.policyLoadFailed': 'Kjøretøyinnstillingen kunne ikke lastes.',
  'r1e.annual.yearEndRequired': 'Årsavslutning for {year} må fullføres før årsregnskapet kan endres.',
  'r1e.vehiclePolicy.pickDateAndMode': 'Velg gyldig dato og kjøretøyinnstilling.',
  'r1e.vehiclePolicy.confirmResponsibility': 'Du må bekrefte at foretaket selv holder opplysningen oppdatert.',
  'r1e.zip.unknownContent': 'Ukjent filinnhold i zip-arkivet.',
  'r1e.zip.noFiles': 'Ingen filer å pakke.',
  'r1e.reconFinish.unavailable': 'Avstemming er ikke tilgjengelig ennå.',
  'r1e.reconFinish.statementMissing': 'Mangler bankutskrift.',
});
